export default [
  {
    title: 'داشبورد',
    icon: 'HomeIcon',
    route: 'dashboard',

    // tag: '2',
    // tagVariant: 'light-warning',
    // children: [
    //   {
    //     title: 'داشبورد',
    //     route: 'dashboard',
    //   },
    // ],
  },
]
